/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
import React, { useState, useContext, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import * as actions from '../actions';
import * as c from '../constants';

function RollbackModal({
  id,
  rollbackPayment,
  rollingback,
  onClear,
}) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState({
    remarks: '',
  });

  const validateForm = useFormValidator(formData, {
    remarks: 'required',
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    const args = {
      transaction_history_id: id,
      remarks: _.get(
        formData,
        'remarks'
      ),
    };

    rollbackPayment(args, () => {
      onClear(e);
      setModal({ isOpen: false });
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };


  const onChange = (e) => {
    return setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleSubmit} className="pt-2">
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label mb-1">
              Remarks{' '}
              {validateForm.renderMessage('remarks')}
            </label>
            <textarea
              rows={5}
              className="form-control"
              type="text"
              name="remarks"
              onChange={onChange}
              value={_.get(formData, 'remarks') || ''}
            />
          </div>
        </div>
        <div className="row d-flex justify-content-center pt-2">
          <div>
            <button
              type="submit"
              className="btn btn-primary cms-bg-color-primary cms-outline-primary mr-1"
              disabled={rollingback || !validateForm.response.is_passed}
            >
              Rollback
            </button>
            <button
              type="button"
              onClick={closeModal}
              className="btn btn-dark"
            >
              <span className="font-weight-bold">Close</span>
            </button>
          </div>
        </div>
      </form>
    </Modal.Body>
  );
}

RollbackModal.propTypes = {
  id: PropTypes.string.isRequired,
  rollbackPayment: PropTypes.instanceOf(Function).isRequired,
  rollingback: PropTypes.bool.isRequired,
  onClear: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  rollingback: api.loading.indexOf(c.ROLLBACK_PAYMENT) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(RollbackModal);
